// iter-62 — Ephemeral module-level storage for a hero-dropped file.
// Files can't be safely persisted in sessionStorage (5MB quota + base64
// blows up manuscripts). Instead we keep the File object in a module
// variable that survives all in-SPA route changes (Landing → Register →
// Dashboard). If the user reloads the tab or leaves the SPA, the stash
// clears — that's fine, they'll just upload manually. sessionStorage
// still holds the filename so the Register page can show a friendly
// "Continuing with your-book.docx…" line even after a hard reload.

let pendingFile = null;

export function setPendingUpload(file) {
  pendingFile = file || null;
  try {
    if (file) {
      sessionStorage.setItem("bf.hero.pendingFile", file.name);
    } else {
      sessionStorage.removeItem("bf.hero.pendingFile");
    }
  } catch (_) {
    /* privacy mode — safe no-op */
  }
}

export function getPendingUpload() {
  return pendingFile;
}

export function getPendingUploadName() {
  if (pendingFile) return pendingFile.name;
  try {
    return sessionStorage.getItem("bf.hero.pendingFile") || null;
  } catch (_) {
    return null;
  }
}

export function clearPendingUpload() {
  pendingFile = null;
  try {
    sessionStorage.removeItem("bf.hero.pendingFile");
  } catch (_) {}
}
